function removeOptionalParamsFromPath(path = '') {
  const regex = /\/*\(([^)]+)\)/g;
  return path.replace(regex, '');
}

export default removeOptionalParamsFromPath;
